import * as React from 'react'
import type { SVGProps } from 'react'
function SvgAuto217403851918(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 157.5 105.7"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M149.8,35.2c-11.6-13-32.4-11.8-36.8-11.4C100.8,9.4,86.6,1.4,70.6,0.2C41.7-2.1,17.3,18,14.4,20.5L2.9,24 c-0.5,0.1-0.9,0.5-1,1c-2.1,7-3.4,37.7,1.1,49c0.2,0.6,0.8,0.9,1.4,0.9h12.4c0.6,9,8.1,16.2,17.3,16.2c9.2,0,16.7-7.2,17.3-16.2 h55.5c0.6,9,8.1,16.2,17.3,16.2s16.7-7.2,17.3-16.2H154l0,0c0.7,0,1.3-0.5,1.5-1.2C159.5,56.8,157.6,43.8,149.8,35.2z M34.1,88.1 c-7.9,0-14.3-6.4-14.3-14.3c0-7.9,6.4-14.3,14.3-14.3c7.9,0,14.3,6.4,14.3,14.3C48.5,81.6,42,88.1,34.1,88.1z M124.2,88.1 c-7.9,0-14.3-6.4-14.3-14.3c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0,0,0,0,0,0c0.2-7.7,6.5-14,14.3-14c7.7,0,13.9,6.1,14.3,13.7 c0,0.1,0,0.2,0,0.4c0,0.2,0,0.3,0.1,0.4C138.5,81.7,132.1,88.1,124.2,88.1z M152.9,71.9h-11.4c-0.9-8.7-8.3-15.5-17.2-15.5 s-16.3,6.8-17.2,15.5H51.4c-0.9-8.7-8.3-15.5-17.2-15.5c-8.9,0-16.3,6.8-17.2,15.5H5.5C1.8,61,2.8,34.2,4.6,26.6l11-3.3 c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.2,25.4-22,54.3-19.8c14.5,1.1,27.5,8.1,38.7,20.7c-2.2,0.1-5.4,0.2-9.3,0.3 c-20,0.7-57.2,1.9-69.6-0.3c-0.8-0.1-1.6,0.4-1.7,1.2c-0.1,0.8,0.4,1.6,1.2,1.7c5.4,1,15.5,1.3,26.7,1.3c14.9,0,32.1-0.6,43.5-1 c6.2-0.2,11.2-0.4,12.4-0.3c0.1,0,0.3,0,0.4,0c1.7-0.2,23.6-2.3,34.9,10.4C154.5,44.9,156.3,56.6,152.9,71.9z" />
        <polygon points="56.4,28.2 56.4,28.2 56.4,28.2" />
        <path d="M72.5,102.7H21.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h50.9c0.8,0,1.5-0.7,1.5-1.5S73.3,102.7,72.5,102.7z" />
        <path d="M135.9,102.7h-27.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h27.6c0.8,0,1.5-0.7,1.5-1.5 S136.8,102.7,135.9,102.7z" />
        <path d="M97,102.7H83.8c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H97c0.8,0,1.5-0.7,1.5-1.5S97.8,102.7,97,102.7z" />
      </g>
    </svg>
  )
}
export default SvgAuto217403851918
